import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContratoDetalharRoutingModule } from "./contrato-detalhar-routing.module";
import { ContratoDetalharComponent } from "./contrato-detalhar.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { DividerModule } from "primeng/divider";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";
import { TooltipModule } from "primeng/tooltip";



@NgModule({
    imports: [
        CommonModule,
        ContratoDetalharRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        DividerModule,
        InputMaskModule,
        FormatPipeModule,
        ProgressSpinnerModule,
        MessagesModule,
        TooltipModule

    ],
    declarations: [ContratoDetalharComponent]
})
export class ContratoDetalharModule { }
